import { render, staticRenderFns } from "./registerProtocol.vue?vue&type=template&id=206de0ac&scoped=true"
import script from "./registerProtocol.vue?vue&type=script&lang=js"
export * from "./registerProtocol.vue?vue&type=script&lang=js"
import style0 from "./registerProtocol.vue?vue&type=style&index=0&id=206de0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206de0ac",
  null
  
)

export default component.exports